export default "__VITE_ASSET__kFpdRXog__"